import React, { useState } from "react";
import ReactDOM from "react-dom/client";
import "./styles/index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(document.getElementById("root"));


export const AppContext = React.createContext({});

root.render(
  <RootApp />
);

function RootApp() {
  const [appData, setAppData] = useState({});
  return (
    <AppContext.Provider value={{
      appData,
      setAppData
    }}>
      <App />
    </AppContext.Provider>
  )
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
